export function currentFTProgress(currentFTProgress: any[]): string {
  if(currentFTProgress.length < 1) return '';
  let currentProcessProgress: any = '';
  let currentProcessIndex: number = -1;
  for (let i = 0; i < currentFTProgress.length; i++) {
    const processProgress = currentFTProgress[i];
    if(processProgress.progress < 100) {
      currentProcessProgress = processProgress;
      currentProcessIndex = i + 1;
      break;
    }
  }
  if(!currentProcessProgress) {
    currentProcessIndex = currentFTProgress.length;
    currentProcessProgress = currentFTProgress[currentProcessIndex - 1];
  }
  return `${currentProcessProgress.type}: ${Number(currentProcessProgress.progress).toFixed()}% (${currentProcessIndex}/${currentFTProgress.length})`;
}